import * as React from 'react';

import {IframeComponent} from 'shells/iframe/iframe-component';

import {PageContainer, PageTitleBar} from '../../../layout';

export function MarketingResourcesPage() {
    return (
        <PageContainer
            title='Marketing Resources'
            noPadding={true}
            pageTitleBar={
                <PageTitleBar
                    title='Marketing Resources'
                    subheaderPrimaryText='Download these free resources to help you increase the amount of qualified leads in your pipeline'
                />
            }
        >
            <IframeComponent
                src='https://www.nutshell.com/marketing-guides'
                title='Marketing guides'
            />
        </PageContainer>
    );
}
